/* eslint-disable react/no-unescaped-entities */
/* eslint-disable @next/next/no-img-element */
import { useRouter } from 'next/router';
import { useTranslation } from 'react-i18next';
import Footer from '@buddieshr/components/footer';
import Header from '@buddieshr/components/header';
import MetaHeader from '@buddieshr/components/metaHeader';
import styles from '@buddieshr/styles/use-cases/remote.module.scss';
import Link from 'next/link';
import PageWrapper from '@buddieshr/components/templates/pageWrapper';
import { Button, Tag } from 'antd';
import TextBackground from '@buddieshr/components/text/textBackground';
import IndividualAppVignette from '@buddieshr/components/IndividualAppVignette';
import { PRODUCTS } from '@buddieshr/utils/constants-products';
import { CheckCircleFilled, CloseCircleFilled } from '@ant-design/icons';

export default function RemoteTeams(pageProps) {
  const router = useRouter();
  const { t } = useTranslation();

  return (
    <>
      <MetaHeader
        title={"Engage a Remote Team with BuddiesHR suite of apps for Slack"}
        description={t('descriptionRemoteTeams')}
        currentURL={`https://buddieshr.com/${
          router.locale === 'en' ? '' : router.locale
        }/use-cases/remote`}
        currentShare={`https://buddieshr.com/img/share_preview_1.png`}
        pageSlug={`use-cases/remote`}
        locale={router.locale}
      />
      <Header />

      <div className={styles.container}>
        <main>
          <div className={`${styles.Page_wrapper} ${styles.Remote_wrapper}`}>
            <div className={styles.Remote_inner}>
              <div
                className={styles.Page_header_wrapper}
                style={{ background: 'none' }}
              >
                <Tag color="blue" className={styles.tag}>
                  BUILT FOR REMOTE TEAMS
                </Tag>
                <h1
                  className={styles.bold}
                  style={{
                    width: 690,
                    maxWidth: '100%',
                    marginLeft: 'auto',
                    color: '#1f3a45',
                    marginRight: 'auto',
                    marginTop: 12,
                  }}
                >
                  Engage a <TextBackground>Remote Team</TextBackground> with
                  BuddiesHR suite of apps for Slack
                </h1>
                <div
                  style={{ color: '#1f3a45' }}
                  className={styles.Page_header_description}
                >
                  Although engaging a remote team can be challenging, BuddiesHR
                  can help facilitate team cohesion by connecting employees
                  together.
                </div>
                <div
                  className={styles.Top_header_actions}
                  style={{ marginTop: '26px' }}
                >
                  <div className={styles.Top_header_actions_link}>
                    <Link href="/#products">
                      <Button type="link" size="large">
                        View Features
                      </Button>
                    </Link>
                  </div>
                  <div>
                    <Link href="/get-started">
                      <Button
                        // icon={<CaretRightOutlined />}
                        type="primary"
                        size="large"
                        style={{ minWidth: 230 }}
                      >
                        Get started for free
                      </Button>
                    </Link>
                  </div>
                </div>
              </div>
              <div className={styles.problemWrapper}>
                <PageWrapper width={800}>
                  <Tag
                    color="red"
                    className={styles.tag}
                    style={{ marginBottom: 12 }}
                  >
                    REMOTE ENGAGEMENT PROBLEM
                  </Tag>
                  <h2>
                    What issues do companies face with Employee engagement when
                    working remotely?
                  </h2>
                  <p>
                    When working remotely or hybrid, a few issue can arise and
                    engagement can drop.
                  </p>
                  <br />
                  Issues include :
                  <ul>
                    <li>
                      <div className={styles.linner}>
                        <CloseCircleFilled className={styles.icon} />
                        <div className={styles.licontent}>
                          {' '}
                          Employees feeling lonely
                        </div>
                      </div>
                    </li>
                    <li>
                      <div className={styles.linner}>
                        <CloseCircleFilled className={styles.icon} />
                        <div className={styles.licontent}>
                          Poor motivation leading to poor productivity
                        </div>
                      </div>
                    </li>
                    <li>
                      <div className={styles.linner}>
                        <CloseCircleFilled className={styles.icon} />
                        <div className={styles.licontent}>
                          Company culture falling flat
                        </div>
                      </div>
                    </li>
                    <li>
                      <div className={styles.linner}>
                        <CloseCircleFilled className={styles.icon} />
                        <div className={styles.licontent}>
                          Company belonging inexistent
                        </div>
                      </div>
                    </li>
                    <li>
                      <div className={styles.linner}>
                        <CloseCircleFilled className={styles.icon} />
                        <div className={styles.licontent}>
                          Poor connexion between employees (teamwork becomes
                          difficult, no cross team communication)
                        </div>
                      </div>
                    </li>
                    <li>
                      <div className={styles.linner}>
                        <CloseCircleFilled className={styles.icon} />
                        <div className={styles.licontent}>
                          Lack of social interaction leading to poor morale and
                          depression
                        </div>
                      </div>
                    </li>
                  </ul>
                </PageWrapper>
              </div>

              <div className={styles.solutionsWrapper}>
                <PageWrapper width={800}>
                  <Tag
                    color="green"
                    className={styles.tag}
                    style={{ marginBottom: 12 }}
                  >
                    BUDDIESHR SOLUTION
                  </Tag>
                  <h2>How to solve the remote employee engagement?</h2>
                  <p>
                    BuddiesHR offers a comprehensive solution for fixing the
                    engagement problem that remote and hybrid companies can see.
                  </p>
                  <br />
                  <p>By using BuddiesHR apps for Slack you're able to :</p>
                  <ul>
                    <li>
                      <div className={styles.linner}>
                        <CheckCircleFilled className={styles.icon} />
                        <div className={styles.licontent}>
                          Connect your team together
                        </div>
                      </div>
                    </li>
                    <li>
                      <div className={styles.linner}>
                        <CheckCircleFilled className={styles.icon} />
                        <div className={styles.licontent}>
                          Make sure employees know your company values
                        </div>
                      </div>
                    </li>
                    <li>
                      <div className={styles.linner}>
                        <CheckCircleFilled className={styles.icon} />
                        <div className={styles.licontent}>
                          Recognize good work and contributions
                        </div>
                      </div>
                    </li>
                    <li>
                      <div className={styles.linner}>
                        <CheckCircleFilled className={styles.icon} />
                        <div className={styles.licontent}>
                          Celebrate wins and important dates as a team
                        </div>
                      </div>
                    </li>
                    <li>
                      <div className={styles.linner}>
                        <CheckCircleFilled className={styles.icon} />
                        <div className={styles.licontent}>
                          Gather feedback and monitor employee satisfaction
                        </div>
                      </div>
                    </li>
                    <li>
                      <div className={styles.linner}>
                        <CheckCircleFilled className={styles.icon} />
                        <div className={styles.licontent}>
                          Visualize and present your organisation structure
                        </div>
                      </div>
                    </li>
                    <li>
                      <div className={styles.linner}>
                        <CheckCircleFilled className={styles.icon} />
                        <div className={styles.licontent}>
                          Save hours of time by automating reminders and
                          repetitive tasks (birthdays, standups, surveys etc.)
                        </div>
                      </div>
                    </li>
                  </ul>
                </PageWrapper>
              </div>
              <div className={styles.installWrapper}>
                <div className={styles.installInner}>
                  <div className={styles.list}>
                    {PRODUCTS.map((p) =>
                      p.show ? (
                        <IndividualAppVignette
                          key={p.id}
                          app={p}
                          className={styles.dreamTeamItem}
                          withDescription={false}
                          withAction={false}
                          withLastName={false}
                        />
                      ) : (
                        <></>
                      )
                    )}
                  </div>
                  <h2 style={{ marginTop: 18, marginBottom: 16 }}>
                    Choose the Best Employee Engagement software for Slack,
                    Install BuddiesHR
                  </h2>
                  <p>
                    ✅&nbsp;Install only what you need&nbsp;✅&nbsp;Quick
                    install &nbsp;✅&nbsp; 30 days free trial without any credit
                    card needed.
                  </p>
                  <br />
                  <Link
                    href={`/get-started`}
                    alt={'Get started with Buddieshr for free'}
                  >
                    <Button
                      type="primary"
                      block
                      size="large"
                      style={{ width: 300, maxWidth: '100%' }}
                    >
                      Get Started for free
                    </Button>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </main>
        <Footer />
      </div>
    </>
  );
}
